import { AutogenLayoutOpportunityList } from "./autogen/AutogenLayoutOpportunityList";


export class OpportunityList extends AutogenLayoutOpportunityList {
    onLoad(): void | Promise<void> {
        this.tableOpportunities.addButtonCaption = "Add Opportunity";
    }
}